<template>
  <div class="q-mb-sm q-mt-sm">
    <draggable
      v-if="value.length"
      :list="value"
      itemKey="image"
      v-bind="{
        animation: 200,
        group: optionType,
        disabled: false,
      }"
      @change="(evt) => onDragEnd(evt, value)"
      handle=".cursor-move"
      :component-data="{
        type: 'transition-group',
        name: 'drag-area',
        class: 'q-list q-list--dense q-list--separator',
      }"
      :forceFallback="true"
      fallbackClass="dragging-item"
    >
      <template #item="{ index }">
        <div class="q-pa-none horizontal-line">
          <q-item class="q-pa-none">
            <q-item-section avatar class="cursor-move">
              <div class="row q-gutter-xs">
                <q-icon name="drag_indicator" color="grey" size="xs" />
                <div class="text-brand-grey" v-if="optionType === 'select'">{{ index + 1  }}.</div>
                <q-icon name="crop_square" color="grey" size="xs" v-if="optionType === 'checkbox'"/>
                <q-icon name="radio_button_unchecked" color="grey" size="xs" v-if="optionType === 'radio'"/>
              </div>
            </q-item-section>
            <q-item-section>
              <q-input
                dense
                borderless
                lazy-rules
                v-model="value[index]"
                :rules="[(val) => (val && val.length > 0) || requiredRule.fieldName]"
                :placeholder="$t('label.common.form_liff.answer_select')"
              />
            </q-item-section>
            <q-item-section side>
              <div class="q-gutter-xs">
                <q-btn
                  flat
                  round
                  no-caps
                  color="black"
                  size="sm"
                  icon="close"
                  @click="handleDeleteAnswer(index)"
                  :disabled="value.length === 1 && !isDeleteFirst"
                />
              </div>
            </q-item-section>
          </q-item>
        </div>
      </template>
    </draggable>
    <div class="q-pa-none">
      <q-item class="q-pa-none horizontal-line">
        <q-item-section avatar class="cursor-move">
          <div class="row q-gutter-xs">
            <div style="width: 18px;"></div>
            <div class="text-brand-grey" v-if="optionType === 'select'">{{ value.length + 1  }}.</div>
            <q-icon name="crop_square" color="grey" size="xs" v-if="optionType === 'checkbox'"/>
            <q-icon name="radio_button_unchecked" color="grey" size="xs" v-if="optionType === 'radio'"/>
          </div>
        </q-item-section>
        <q-item-section>
          <q-input
            dense
            borderless
            v-model="currentAnswer"
            :placeholder="$t('label.common.form_liff.answer_select')"
            @keydown.enter.prevent="handleAddAnswer"
          />
        </q-item-section>
      </q-item>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import draggable from 'vuedraggable'
import { Prop } from 'vue-property-decorator'
import { calcOrderingDragend } from '@/utils/helpers'
import { maska } from 'maska'

@Options({
  components: { draggable },
  directives: { maska },
  emits: ['update:modelValue', 'update:quantityItem'],
})
export default class FormLIFFOption extends Vue {
  @Prop({ default: [] })
  modelValue!: string[]

  @Prop()
  isDeleteFirst!: boolean

  @Prop({ default: 'select' })
  optionType!: string

  countAnswer = 0
  currentAnswer = ''

  get value() {
    return this.modelValue
  }

  set value(value: string[]) {
    this.$emit('update:modelValue', value)
  }

  get requiredRule() {
    return {
      fieldName: this.$t('validate.this_field_is_required', {
        placeholder: this.$t('label.form.field_name'),
      }),
    }
  }

  handleAddAnswer() {
    const trimmed = this.currentAnswer.trim()
    if (!trimmed) return

    const newValue = [...this.value, trimmed]
    this.value = newValue

    this.currentAnswer = ''

    if (newValue.length === 1) {
      this.$emit('update:quantityItem', newValue.length)
    }
  }

  handleDeleteAnswer(index: number): void {
    if (this.value) {
      this.value.splice(index, 1)
      this.countAnswer = index - 1
    }

    if (this.value.length === 0) {
      this.$emit('update:quantityItem', this.value.length)
    }
  }

  async onDragEnd(evt: any, finalList: string[]) {
    if (!evt.moved) {
      return
    }

    const record = evt.moved.element
    calcOrderingDragend(record, finalList)
  }
}
</script>

<style scoped lang="scss">
.q-field--with-bottom {
  padding-top: 0;
  padding-bottom: 0;
}
.first-line .q-field--with-bottom {
  padding-top: 0;
}
.first-line {
  justify-content: flex-start !important;
}
:deep(.q-field__label) {
  font-size: 12px !important;
}
:deep(.q-item__section--side) {
  padding-right: 8px;
}
</style>
